import { z } from "zod";
import { CountryFilterSchema } from "../../../services/cm-report/schema/CountryFilterSchema";
import { SalesFilterSchema } from "../../../services/cm-report/schema/SalesFilterSchema";
import { DailyFilterSchema } from "../../../services/cm-report/schema/DailyFilterSchema";
import { ReportSalesMonthlyFilterSchema } from "../../../services/cm-report/schema/ReportSalesMonthlySchema";
import { ReportReservationFilterSchema } from "../../../services/cm-report/schema/ReportReservationSchema";
import { ReportAgentFilterSchema } from "../../../services/cm-report/schema/ReportAgentFilterSchema";
import { ReportRoomFilterSchema } from "../../../services/cm-report/schema/ReportRoomFilterSchema";

const BaseSchema = z.object({
    report_type: z.enum(["country_report", "sales_report", "daily_report", "report_sales_monthly", "report_reservation", "report_agent", "room_report"])
});

const CountryReportSchema = BaseSchema.extend({ filter: CountryFilterSchema });
const SalesReportSchema = BaseSchema.extend({ filter: SalesFilterSchema });
const DailyReportSchema = BaseSchema.extend({ filter: DailyFilterSchema });
const ReportSalesMonthlySchema = BaseSchema.extend({ filter: ReportSalesMonthlyFilterSchema });
const ReportReservationSchema = BaseSchema.extend({ filter: ReportReservationFilterSchema });
const ReportAgentSchema = BaseSchema.extend({ filter: ReportAgentFilterSchema });
const RoomReportSchema = BaseSchema.extend({ filter: ReportRoomFilterSchema });

export const schemaMap = {
    country_report: CountryReportSchema,
    sales_report: SalesReportSchema,
    daily_report: DailyReportSchema,
    report_sales_monthly: ReportSalesMonthlySchema,
    report_reservation: ReportReservationSchema,
    report_agent: ReportAgentSchema,
    room_report: RoomReportSchema
};

export const defaultValuesMap = {
    country_report: { report_type: "country_report", filter: { property_id: "", base_on: "checkin_date", start_date: "", end_date: "", room_type_id: "" } },
    sales_report: { report_type: "sales_report", filter: { property_id: "", base_on: "checkout_date", start_date: "", end_date: "" } },
    daily_report: { report_type: "daily_report", filter: { property_id: "", start_date: "", end_date: "", ota_code: "", agent_id: "" } },
    report_sales_monthly: { report_type: "report_sales_monthly", filter: { property_id: "", base_on: "created_reservation", start_date: "", end_date: "", room_type_id: "" } },
    report_reservation: { report_type: "report_reservation", filter: { property_id: "", base_on: "created_reservation", start_date: "", end_date: "", room_type_id: "" } },
    report_agent: { report_type: "report_agent", filter: { property_id: "", base_on: "stay_date", start_date: "", end_date: "", room_type_id: "" } },
    room_report: { report_type: "room_report", filter: { property_id: "", base_on: "stay_date", start_date: "", end_date: "" } }
};
